import {Card} from 'platform/components';
import {Heading, HStack, Icon, VStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {Payment} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {PaymentOverview} from './PaymentOverview';

interface CorrectiveTaxDocumentsListProps extends RequiredTestIdProps {
  correctivePayments: Payment[] | Nullish;
  checkoutId: string;
  serviceCaseId?: string;
  serviceOrderId?: string;
}

export function CorrectiveTaxDocumentsList(props: CorrectiveTaxDocumentsListProps) {
  if (isNilOrEmpty(props.correctivePayments)) {
    return null;
  }

  return (
    <VStack spacing={4}>
      <HStack spacing={2}>
        <Icon value="editor/insert_drive_file" />
        <Heading size={4}>{i18n.t('entity.accounting.labels.correctiveTaxDocuments')}</Heading>
      </HStack>
      {props.correctivePayments?.map((payment, index) => (
        <Card variant="inlineGrey" key={payment.checkoutPaymentId}>
          <PaymentOverview
            payment={payment}
            isCorrectivePayment
            checkoutId={props.checkoutId}
            serviceCaseId={props.serviceCaseId}
            serviceOrderId={props.serviceOrderId}
            data-testid={suffixTestId(`document-${index}`, props)}
          />
        </Card>
      ))}
    </VStack>
  );
}
